<template>
  <div class="wecom-kf-insight">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="统计时间：">
          <el-date-picker v-model="dateRange" type="daterange" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 340px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="query">查询</el-button>
          <el-button :loading="building" @click="build">生成主题汇总</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <p class="score-standard">质检分是 1 到 5 分，<b>分越高越好</b>。1 差，2 较差，3 一般，4 良好，5 好。正确看有没有答错；规范看是否按业务规则说；态度看语气是否礼貌、有耐心；认真看有没有把问题说明白并给出下一步，1 分是敷衍。</p>

    <el-row :gutter="16" class="summary-section">
      <el-col :span="4">
        <el-card shadow="never" class="summary-card">
          <div class="summary-number">{{ view.sessionCount || 0 }}</div>
          <div class="summary-label">结束会话</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="summary-card">
          <div class="summary-number">{{ formatDuration(view.avgFirstResponseSeconds) }}</div>
          <div class="summary-label">平均首响</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="summary-card">
          <div class="summary-number">{{ view.timeoutRate | percentFilter }}</div>
          <div class="summary-label">超时率</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="summary-card">
          <div class="summary-number">{{ scoreText(view.avgRuleCompliance) }}</div>
          <div class="summary-label">规范均分</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card shadow="never" class="summary-card">
          <div class="summary-number">{{ scoreText(view.avgAttitude) }}</div>
          <div class="summary-label">态度均分</div>
        </el-card>
      </el-col>
    </el-row>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="业务问题" name="theme">
        <el-table v-loading="loading" :data="view.themes || []" stripe empty-text="所选日期还没有主题汇总">
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column prop="tag" label="吐槽点" min-width="140" />
          <el-table-column prop="count" label="次数" width="80" sortable />
          <el-table-column label="例子" min-width="280">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.examples || []" :key="index" class="example-text">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="suggestion" label="改进建议" min-width="220" show-overflow-tooltip />
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openThemeSessions(scope.row)">查看会话</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="客服考核" name="assess">
        <p class="assess-tip">考核归属为本通回复最多的客服。考核分是正确、规范、态度、认真四项的平均分，同样是 1 到 5 分、越高越好。驳回的质检不计入分数和吐槽会话数。</p>
        <el-table v-loading="loading" :data="view.assessment || []" stripe empty-text="暂无已结束会话">
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column prop="servicerName" label="客服" min-width="120" />
          <el-table-column prop="sessionCount" label="接待会话" width="100" sortable />
          <el-table-column prop="analyzedCount" label="计入质检" width="100" sortable />
          <el-table-column label="平均首响" min-width="110" sortable sort-by="avgFirstResponseSeconds">
            <template slot-scope="scope">{{ formatDuration(scope.row.avgFirstResponseSeconds) }}</template>
          </el-table-column>
          <el-table-column label="超时率" width="100" sortable sort-by="timeoutRate">
            <template slot-scope="scope">{{ scope.row.timeoutRate | percentFilter }}</template>
          </el-table-column>
          <el-table-column label="正确" width="80" sortable sort-by="avgCorrectness">
            <template slot-scope="scope">{{ scoreText(scope.row.avgCorrectness) }}</template>
          </el-table-column>
          <el-table-column label="规范" width="80" sortable sort-by="avgRuleCompliance">
            <template slot-scope="scope">{{ scoreText(scope.row.avgRuleCompliance) }}</template>
          </el-table-column>
          <el-table-column label="态度" width="80" sortable sort-by="avgAttitude">
            <template slot-scope="scope">{{ scoreText(scope.row.avgAttitude) }}</template>
          </el-table-column>
          <el-table-column label="认真程度" width="100" sortable sort-by="avgThoroughness">
            <template slot-scope="scope">{{ scoreText(scope.row.avgThoroughness) }}</template>
          </el-table-column>
          <el-table-column label="考核分" width="90" sortable sort-by="score">
            <template slot-scope="scope">{{ scoreText(scope.row.score) }}</template>
          </el-table-column>
          <el-table-column prop="complaintSessionCount" label="吐槽会话" width="100" sortable />
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openSessions({ servicerUserId: scope.row.servicerUserId || '__NONE__' })">查看会话</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getWecomKfInsight, buildWecomKfInsight } from "@/api/wecom_kf";
import { DateUtil } from "@/util";

function defaultDateRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 6);
  return [DateUtil.format(start, "yyyy-MM-dd"), DateUtil.format(end, "yyyy-MM-dd")];
}

export function formatDuration(seconds) {
  if (seconds == null || seconds === "") {
    return "—";
  }
  const value = Math.round(Number(seconds));
  if (Number.isNaN(value)) {
    return "—";
  }
  if (value < 60) {
    return `${value}秒`;
  }
  const minutes = Math.floor(value / 60);
  const remain = value % 60;
  if (minutes < 60) {
    return remain ? `${minutes}分${remain}秒` : `${minutes}分`;
  }
  const hours = Math.floor(minutes / 60);
  return `${hours}小时${minutes % 60}分`;
}

export function scoreText(value) {
  if (value == null || value === "") {
    return "—";
  }
  const score = Number(value);
  if (Number.isNaN(score)) {
    return "—";
  }
  const level = score <= 1.5 ? "差" : score <= 2.5 ? "较差" : score <= 3.5 ? "一般" : score <= 4.5 ? "良好" : "好";
  const shown = Number.isInteger(score) ? String(score) : score.toFixed(1);
  return `${shown} ${level}`;
}

export default {
  data() {
    return {
      dateRange: defaultDateRange(),
      loading: false,
      building: false,
      activeTab: "theme",
      view: {}
    };
  },
  created() {
    this.query();
  },
  methods: {
    formatDuration,
    scoreText,
    query() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning("请选择日期");
        return;
      }
      this.loading = true;
      getWecomKfInsight({ startDate: this.dateRange[0], endDate: this.dateRange[1] }).then((res) => {
        this.view = res.data || {};
      }).finally(() => {
        this.loading = false;
      });
    },
    build() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning("请选择日期");
        return;
      }
      this.building = true;
      buildWecomKfInsight({ startDate: this.dateRange[0], endDate: this.dateRange[1] }).then(() => {
        this.$message.success("已开始生成，请稍后再次查询");
      }).finally(() => {
        this.building = false;
      });
    },
    openThemeSessions() {
      this.openSessions();
    },
    openSessions(extra) {
      this.$emit("open-sessions", {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        servicerUserId: "",
        tag: "",
        ...extra
      });
    }
  }
};
</script>

<style scoped>
.summary-section {
  margin-bottom: 16px;
}

.summary-card {
  text-align: center;
}

.summary-number {
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
}

.summary-label {
  color: #909399;
  font-size: 13px;
}

.score-standard {
  color: #606266;
  font-size: 13px;
  line-height: 22px;
  margin: 0 0 12px;
}

.assess-tip {
  color: #909399;
  font-size: 13px;
  margin: 0 0 12px;
}

.example-text {
  white-space: normal;
  word-break: break-word;
  line-height: 22px;
}
</style>
